jQuery('.responsive').bgResponsiveImage();
jQuery('.burger').menu();
